"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.SideMenu = void 0;
require("antd/lib/tooltip/style");
var _tooltip = _interopRequireDefault(require("antd/lib/tooltip"));
require("antd/lib/icon/style");
var _icon = _interopRequireDefault(require("antd/lib/icon"));
var _react = _interopRequireDefault(require("react"));
var _reactRouterDom = require("react-router-dom");
var _components = require("../../../components");
var _utils = require("../../../utils");
var _utils2 = require("../utils");
var _ = require("../..");
var _ValuesForCalendarGro;
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function _defineProperty(obj, key, value) { key = _toPropertyKey(key); if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
var ValuesForCalendarGroup = (_ValuesForCalendarGro = {}, _defineProperty(_ValuesForCalendarGro, _utils2.CalendarGroup.MonumentAppointments, {
  checkboxStyles: 'peer-checked:bg-green2-55 ring-green2-55 ring-1 ring-inset',
  checkBoxLabel: 'Monument Appointments'
}), _defineProperty(_ValuesForCalendarGro, _utils2.CalendarGroup.BlockingEvents, {
  checkboxStyles: 'peer-checked:bg-grey-40 ring-grey-40 ring-1 ring-inset',
  checkBoxLabel: 'Blocking Events',
  tooltipTitle: 'Events from connected calendar(s) block off availability. Note: recurring appointments can be scheduled during your blocked availability. If this happens you need to manually cancel the appointments and notify the member.'
}), _defineProperty(_ValuesForCalendarGro, _utils2.CalendarGroup.RecurringAvailability, {
  checkboxStyles: 'peer-checked:bg-orange1-20 ring-orange1-20 ring-1 ring-inset',
  checkBoxLabel: 'Recurring Availability',
  tooltipTitle: 'Time slots where you’re available on a recurring weekly basis.'
}), _defineProperty(_ValuesForCalendarGro, _utils2.CalendarGroup.DateBasedAvailability, {
  checkboxStyles: 'peer-checked:bg-blue1-60 ring-blue1-60 ring-1 ring-inset',
  checkBoxLabel: 'Date-Specific Availability',
  tooltipTitle: 'Expands your recurring availability by adding available time on a specific date.'
}), _ValuesForCalendarGro);
var SideMenuItem = function SideMenuItem(_ref) {
  var calendarGroup = _ref.calendarGroup,
    showCalendarsSet = _ref.showCalendarsSet,
    tooltipTitle = _ref.tooltipTitle,
    checkBoxLabel = _ref.checkBoxLabel,
    _ref$manageLink = _ref.manageLink,
    manageLink = _ref$manageLink === void 0 ? null : _ref$manageLink;
  var _useAuth = (0, _.useAuth)(),
    user = _useAuth.user;
  return /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, /*#__PURE__*/_react.default.createElement("div", {
    className: "mt-3 flex flex-row justify-between items-center gap-x-[8px]"
  }, /*#__PURE__*/_react.default.createElement(_components.Checkbox, {
    name: checkBoxLabel || ValuesForCalendarGroup[calendarGroup].checkBoxLabel,
    checked: showCalendarsSet.has(calendarGroup),
    onChange: function onChange() {
      return showCalendarsSet.toggle(calendarGroup);
    },
    wrapperStyles: "items-center",
    checkboxStyles: ValuesForCalendarGroup[calendarGroup].checkboxStyles,
    labelStyles: "text-[14px] ml-[8px]"
  }, checkBoxLabel || ValuesForCalendarGroup[calendarGroup].checkBoxLabel), /*#__PURE__*/_react.default.createElement(_tooltip.default, {
    title: tooltipTitle || ValuesForCalendarGroup[calendarGroup].tooltipTitle
  }, /*#__PURE__*/_react.default.createElement(_icon.default, {
    type: "info-circle",
    className: "opacity-50 hover:opacity-100"
  }))), manageLink && !(0, _utils.isAdmin)(user) && /*#__PURE__*/_react.default.createElement("div", {
    className: "w-full flex"
  }, /*#__PURE__*/_react.default.createElement(_reactRouterDom.Link, {
    className: "mr-auto mt-[5px]",
    to: manageLink
  }, "Manage")));
};
var SideMenu = function SideMenu(_ref2) {
  var showCalendarsSet = _ref2.showCalendarsSet,
    clinician = _ref2.clinician,
    blockingCalendars = _ref2.blockingCalendars;
  return /*#__PURE__*/_react.default.createElement("div", {
    className: "py-4 max-w-[250px]"
  }, /*#__PURE__*/_react.default.createElement("h2", {
    className: "tw-subtitle-sm-medium text-grey-75"
  }, "Calendar Events"), /*#__PURE__*/_react.default.createElement(SideMenuItem, {
    calendarGroup: _utils2.CalendarGroup.MonumentAppointments,
    showCalendarsSet: showCalendarsSet,
    tooltipTitle: "Appointments with patients scheduled within the Monument system.".concat(!(0, _utils.hasApplicationCalendar)(clinician.cronofySub) ? ' These will also appear directly in your Primary Connected Calendar.' : '')
  }), !(0, _utils.hasApplicationCalendar)(clinician.cronofySub) && /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, /*#__PURE__*/_react.default.createElement(SideMenuItem, {
    calendarGroup: _utils2.CalendarGroup.BlockingEvents,
    showCalendarsSet: showCalendarsSet
  }), /*#__PURE__*/_react.default.createElement("div", {
    className: "text-xs"
  }, blockingCalendars.map(function (calendar) {
    return /*#__PURE__*/_react.default.createElement("div", {
      className: "my-1 flex flex-row items-center",
      key: calendar.calendarId
    }, /*#__PURE__*/_react.default.createElement("div", {
      className: "w-4 h-4 flex justify-center items-center"
    }, /*#__PURE__*/_react.default.createElement("img", {
      alt: "",
      src: _utils.IconForCalendarProvider[calendar.providerName],
      className: "w-3 h-auto"
    })), /*#__PURE__*/_react.default.createElement("div", {
      className: "ml-2 flex-auto"
    }, clinician.cronofyPrimaryCalendarId === calendar.calendarId ? /*#__PURE__*/_react.default.createElement("div", {
      className: "flex flex-row justify-between items-center"
    }, calendar.calendarName, /*#__PURE__*/_react.default.createElement("div", {
      className: "ml-2"
    }, /*#__PURE__*/_react.default.createElement(_tooltip.default, {
      title: "This is your Primary Connected Calendar. Monument appointments get added to this calendar."
    }, /*#__PURE__*/_react.default.createElement(_icon.default, {
      type: "pushpin",
      className: "opacity-50 hover:opacity-100"
    })))) : calendar.calendarName));
  }))), /*#__PURE__*/_react.default.createElement("h2", {
    className: "mt-4 tw-subtitle-sm-medium text-grey-75"
  }, "Your Availability"), /*#__PURE__*/_react.default.createElement(SideMenuItem, {
    calendarGroup: _utils2.CalendarGroup.RecurringAvailability,
    showCalendarsSet: showCalendarsSet,
    checkBoxLabel: (0, _utils.isTherapist)(clinician) ? 'Availability' : 'Recurring Availability',
    manageLink: "".concat(_utils.CLINICIAN_CALENDAR_MANAGE_PARENT_URL, "/").concat(_utils.MANAGE_CALENDAR_TABS.RECURRING)
  }), !(0, _utils.isTherapist)(clinician) && /*#__PURE__*/_react.default.createElement(SideMenuItem, {
    calendarGroup: _utils2.CalendarGroup.DateBasedAvailability,
    showCalendarsSet: showCalendarsSet,
    manageLink: "".concat(_utils.CLINICIAN_CALENDAR_MANAGE_PARENT_URL, "/").concat(_utils.MANAGE_CALENDAR_TABS.DATE_SPECIFIC)
  }), (0, _utils.hasApplicationCalendar)(clinician.cronofySub) && /*#__PURE__*/_react.default.createElement(SideMenuItem, {
    calendarGroup: _utils2.CalendarGroup.BlockingEvents,
    showCalendarsSet: showCalendarsSet,
    checkBoxLabel: "Unavailable Periods",
    tooltipTitle: "Time that you have marked as unavailable or blocked off. This takes precedence over recurring availability or date-specific availability."
  }));
};
exports.SideMenu = SideMenu;